import React from 'react';
import { t } from 'Src/i18n';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  chargePercentage: number;
};
export const PaymentFees = ({ chargePercentage }: Props) => (
  <div className="m-15 text-14" data-testid="paymentMethodFees">
    <TemplateString
      template={t('booking.banking.paymentMethod.percentageChargedDescription')}
      values={{
        percentage_value: `${chargePercentage}%`,
      }}
      valuesClassName={{
        percentage_value: 'font-bold text-saffron',
      }}
    />
  </div>
);
